import ExpansionList from 'components/common/ExpansionList';
import PropTypes from 'prop-types';
import { LOAD, load } from 'model/internalAccount';
import { selectorLoans } from 'selectors/internalAccount';
import { useDispatch, useSelector } from 'react-redux';
import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { useIsBusy, useIsLoading } from 'hooks';
import { ROWS_PER_PAGE } from 'consts';
import { columnMeta, detailsRender, defaultOrderBy } from './config';
import ActionsRenderer from './config/ActionsRenderer';

const PayALoanList = ({ fspId, payerId }) => {
  const dispatch = useDispatch();
  const isBusy = useIsBusy(LOAD);
  const isLoading = useIsLoading(LOAD);
  const items = useSelector((state) => selectorLoans(state, payerId));
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(ROWS_PER_PAGE[0]);

  const pagedItems = useMemo(
    () => items.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
    [items, page, rowsPerPage]
  );

  useEffect(() => {
    dispatch(load({ fspId, payerId }));
  }, [dispatch, fspId, payerId]);

  useEffect(() => {
    setPage(0);
  }, [fspId, payerId]);

  useEffect(() => {
    const maxPage = Math.max(0, Math.ceil(items.length / rowsPerPage) - 1);
    if (page > maxPage) {
      setPage(maxPage);
    }
  }, [items.length, page, rowsPerPage]);

  const handleChange = useCallback(
    (_, { page: nextPage, rowsPerPage: nextRows }) => {
      const nextRpp = Number(nextRows);
      if (nextRpp !== rowsPerPage) {
        setRowsPerPage(nextRpp);
        setPage(0);
      } else {
        setPage(nextPage);
      }
    },
    [rowsPerPage]
  );

  return (
    <ExpansionList
      actionConstant={LOAD}
      ActionsRenderer={ActionsRenderer}
      actionType={LOAD.ACTION}
      columnMeta={columnMeta}
      data={pagedItems}
      detailsRender={detailsRender}
      emptyTitle="No Available Loans"
      fspId={fspId}
      isBusy={isBusy}
      isLoading={isLoading}
      name="payALoan"
      onChange={handleChange}
      orderBy={defaultOrderBy}
      page={page}
      payerId={payerId}
      rowsPerPage={rowsPerPage}
      total={items.length}
    />
  );
};

PayALoanList.propTypes = {
  fspId: PropTypes.number.isRequired,
  payerId: PropTypes.number.isRequired,
};

export default memo(PayALoanList);
